module.exports = __webpack_public_path__ + "static/img/wechat_qrcode.e8503c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wechat_qrcode.png
// module id = cKGo
// module chunks = 1